import { useCallback } from 'react';
import { router, usePathname, type Href } from 'expo-router';
import { useUIStore } from '../store/uiStore';
import { useStructuresStore } from '../store/structuresStore';

/**
 * Press handler for the Guidance tab (GlobalFloatingTabBar + SidebarNav):
 * re-summons MapPathsOverlay, the map's call-to-action block, instead of
 * routing or opening a sheet (the old GuidanceSheet is retired). The tab has
 * no route of its own, so pressing it from anywhere other than the map has
 * to land there first — mirrors the old sheet's handleGotIt, which used the
 * same dismissTo('/') for the reverse trip.
 *
 * MapPathsOverlay refuses to render over a selected structure or an open
 * sheet (its live gates) — correct for the auto-show, but for an explicit
 * Guidance press it read as the tab doing nothing (Jason hit this on the
 * map with the docked panel open, Aug 19). The press is unambiguous intent,
 * so clear both blockers first.
 */
export function useOpenMapPathsOverlay() {
  const pathname = usePathname();
  const requestMapPathsOverlay = useUIStore((s) => s.requestMapPathsOverlay);

  return useCallback(() => {
    useStructuresStore.getState().selectStructure(null);
    if (useUIStore.getState().activeSheet !== null) {
      useUIStore.getState().closeSheet();
    }
    // Same navigation the Community tab performs. dismissTo('/') was a
    // no-op whenever '/' wasn't beneath the current route in history (a
    // direct load or reload on /feed, /alerts, ...), so the map screen —
    // and the overlay it renders — never mounted and the press looked
    // dead (Jason's second live report, Aug 19).
    if (pathname !== '/') router.push('/(tabs)' as Href);
    requestMapPathsOverlay();
  }, [pathname, requestMapPathsOverlay]);
}
